import { FC } from 'react';

import styled from 'styled-components';

import SearchBarDateRangeInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarRangeDatePickerInput/SearchBarDateRangePickerInput';
import { getDateRangePickerPlaceholder } from '@components/views/flight/listing/SearchBar/DateSelect/utils';
import { useCustomMobileDesktopBreakpoint } from '@hooks/hooks';
import {
  DateType,
  getCurrentDate,
  isInclusivelyAfterDay,
} from '@utils/dateUtil';
import { LANDING_BREAKPOINT_VALUE } from '@utils/theme/breakPoint';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';

import ResponsiveDateRangeSelect from './responsiveSearchDrawerItem/ResponsiveDateRangeSelect';

const BookerSearchBarDateRangeInputWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.white};
`;

const HotelBookerDatePicker: FC<{
  setLocalStartDate: React.Dispatch<React.SetStateAction<DateType | null>>;
  setLocalEndDate: React.Dispatch<React.SetStateAction<DateType | null>>;
  localStartDate: DateType | null;
  localEndDate: DateType | null;
  dateChange: (dates?: {
    startDate?: DateType | null;
    endDate?: DateType | null;
  }) => void;
  isSubmit?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
}> = ({
  dateChange,
  setLocalEndDate,
  setLocalStartDate,
  localStartDate,
  localEndDate,
  isSubmit,
  onFocus,
  onBlur,
}) => {
  const setDates = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setLocalStartDate(startDate);
    setLocalEndDate(endDate);
    if (startDate && endDate) dateChange({ startDate, endDate });
  };
  const { xl } = useCustomMobileDesktopBreakpoint(LANDING_BREAKPOINT_VALUE);

  return (
    <BookerSearchBarDateRangeInputWrapper>
      {xl ? (
        <SearchBarDateRangeInput
          label='Ne Kadar Kalacaksınız?'
          dateProps={{
            startDate: localStartDate,
            endDate: localEndDate,
            onDatesChange: setDates,
            isOutsideRange: (day) =>
              !isInclusivelyAfterDay(day, getCurrentDate()),
          }}
          inputComponent='shopAndFlyHomePageHotel'
          isSubmit={isSubmit}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      ) : (
        <LocationAnimationErrorBox hasError={false}>
          <ResponsiveDateRangeSelect
            startDate={localStartDate}
            endDate={localEndDate}
            onDatesChange={setDates}
            title='Gidiş-Dönüş Tarihiniz?'
            subTitle={getDateRangePickerPlaceholder(
              localStartDate,
              localEndDate
            )}
            placeholder='Gidiş - Dönüş Tarihleri'
            drawerTitle='Tarih Arama'
            arrowIcon={true}
            inputComponent='shopAndFlyHomePageHotel'
            isSubmit={isSubmit}
          />
        </LocationAnimationErrorBox>
      )}
    </BookerSearchBarDateRangeInputWrapper>
  );
};
export default HotelBookerDatePicker;
